import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const workOrderServicesColumns: GridColumnConfig[] = [
  {
    title: 'Sort Order',
    field: 'sortOrder',
    filter: 'text',
    editor: 'numeric'
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Code',
    field: 'serviceCode',
    filter: 'text',
    searchable: true,
  },
  //   {
  //     title: 'Service Code',
  //     field: 'serviceCode',
  //     filter: 'text',
  //     searchable: true,
  //     editable: true,
  //   },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Group',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
  },

  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
    searchable: true,
  },
  // {
  //   title: 'Forecast Days',
  //   field: 'forecastDays',
  //   filter: 'text',
  //   editable: true,
  //   editor: 'numeric',
  // },
  {
    title: 'Invoice Amount ($)',
    field: 'price',
    filter: 'numeric',
    fieldType: 'currency',
    editable: true,
    editor: 'numeric',
    isDecimal: true,
  },
  {
    title: 'Invoice Term',
    field: 'invoiceTerm',
    filter: 'text',
    editable: true,
    editor: 'select',
    options: [
      { value: 'endofmonth', label: 'End of Month' },
      { value: 'projectcompletion', label: 'Project Completion' },
      { value: 'lotcompletion', label: 'Lot/Unit Completion' }
    ],
  },
  {
    title: ' ',
    field: 'warning',
    filter: 'text',
    searchable: false,
    width: '60px',
  },
];
